import axios from "axios";

const AxiosInstance = axios.create({
  baseURL: "https://backend.ansuadutta.com", // Replace with your API base URL
  // baseURL: "http://localhost:8003",
});

export default AxiosInstance;
